(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/build-row.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/build-row.js'); "use strict";


const buildRow = (gameAnalyzes, system) => {
  const row = [];
  gameAnalyzes.forEach(g => {
    if (g.parsedPrediction && g.parsedPrediction.prediction && Array.isArray(g.parsedPrediction.prediction)) {
      const predictions = g.parsedPrediction.prediction;
      let outcomes = [];
      for (let i = 0; i < predictions.length; ++i) {
        if (predictions[i] && predictions[i].system === system) {
          outcomes = predictions[i].outcomes;
          break;
        }
      }

      if (outcomes.length >= 1) {

        outcomes.sort((a, b) => a.key - b.key);
        row.push(outcomes.map(o => o.outcomeNumber).join(''));
      }
    }
  });
  const stringifedRow = row.join(',');
  if (stringifedRow.length === 0) {
    return null;
  }
  return stringifedRow;
};
if (svs.isServer) {
  module.exports = buildRow;
} else {
  setGlobal('svs.sport.gameAnalyzes.buildRow', buildRow);
}
 })(window);